import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-social-tiktok',
  template: '<router-outlet></router-outlet>',
  styles: [],
})
export class SocialTiktokComponent implements OnInit {

static NAME = 'icc-msg-social';

  constructor() {}

  ngOnInit() {}
}
